import { render, staticRenderFns } from "./RemoveProposalProduct.vue?vue&type=template&id=406ebcbe&"
import script from "./RemoveProposalProduct.vue?vue&type=script&lang=js&"
export * from "./RemoveProposalProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports